<nav class="navbar navbar-light justify-content-between">
    <div class="d-flex flex-row col-6 hide-sm p-0">
        <!-- <button *ngIf="openBlock" class="btn btn-gray mr-2" (click)="addBlock()"><span class="icon"><i class="fas fa-plus"></i></span></button> -->
        <button *ngIf="openBlock" class="btn btn-gray" mat-button [matMenuTriggerFor]="menu1"><span class="icon"><i class="fas fa-cog"></i></span></button>
        <mat-menu #menu1="matMenu" yPosition="below" class="settings-menu">
            <h5 class="section-title mt-2">DESIGN</h5>
            <div class="block">
                <div class="row ml-0">
                    <span class="icon-gray"><i class="fas fa-sort-amount-up-alt"></i></span>
                    <span class="box-title ml-2">Reorder Blocks</span>
                </div>
            </div>
            <div class="block">
                <div class="row ml-0">
                    <span class="icon-gray"><i class="fas fa-text-height"></i></span>
                    <span class="box-title ml-2">Fonts & Styles</span>
                </div>
            </div>
            <div class="block">
                <div class="row ml-0">
                    <span class="icon-gray"><i class="fas fa-store"></i></span>
                    <span class="box-title ml-2">Store Design</span>
                </div>
            </div>
            <h5 class="section-title">CONFIGURATION</h5>
            <div class="block">
                <div class="row ml-0">
                    <span class="icon-gray"><i class="fas fa-search"></i></span>
                    <span class="box-title ml-2">SEO</span>
                </div>
            </div>
            <div class="block">
                <div class="row ml-0">
                    <span class="icon-gray"><i class="fas fa-globe"></i></span>
                    <span class="box-title ml-2">Domain</span>
                </div>
            </div>
            <div class="block">
                <div class="row ml-0">
                    <span class="icon-gray"><i class="fas fa-chart-bar"></i></span>
                    <span class="box-title ml-2">Tracking & Analytics</span>
                </div>
            </div>
        </mat-menu>
        <button *ngIf="openActiveBlock || openAddBlock" class="btn btn-gray btn-back" (click)="toggleBlock('')">
            <span class="icon">Back</span>
        </button>
        <a href="{{instant_site_link}}" target="_blank">
            <h4 class="navbar-title">Your Instant Site <img class="link-btn" src="../../../assets/icon/link.svg" alt="link"></h4>
        </a>
    </div>
    <div class="show-sm">
        <button *ngIf="openActiveBlock || openAddBlock" class="btn btn-gray btn-back mr-2" (click)="toggleBlock('')">
            <span class="icon"><i class="fas fa-arrow-left"></i></span>
        </button>
        <a href="{{instant_site_link}}" target="_blank" class="btn btn-gray"><span class="icon" style="margin-top: 0px;"><i class="fas fa-external-link-alt"></i></span></a>
    </div>
    <div class="col-6 d-flex justify-content-end p-0">
        <form class="form-inline">
            <button *ngIf="!newChanges" class="btn btn-site-publish" type="submit" disabled>Site published</button>
            <!-- <div *ngIf="newChanges" class="section-unpublished d-flex flex-row hide-md" [matMenuTriggerFor]="menu2">
                <span class="blue-bullet"></span>
                <h4 class="title">Unpublished Changes</h4>
                <span class="arrow-icon">
                    <i class="arrow down"></i>
                </span>
            </div> -->
            <mat-menu #menu2="matMenu" class="changes-menu">
                <div>
                    <p class="text-secondary">Draft saved a few seconds ago</p>
                    <p class="text-secondary">All changes you make are automatically saved to draft.</p>
                </div>
                <div class="d-flex flex-row btn-box">
                    <span class="section-icon">
                        <i class="fas fa-eye icon"></i>
                    </span>
                    <span class="title">Preview Changes</span>
                </div>
                <div class="d-flex flex-row btn-box">
                    <span class="section-icon">
                        <i class="fas fa-redo icon"></i>
                    </span>
                    <span class="title">Discard Changes</span>
                </div>
            </mat-menu>
            <button *ngIf="newChanges" class="btn btn-publish mr-2" type="submit" (click)="discardChanges()" >Discard Changes</button>
            <button *ngIf="newChanges" class="btn btn-publish mr-2" type="submit" (click)="publish()" >Publish</button>
            <!--<button class="btn btn-publish ml-2" type="submit" (click)="edit()">Edit</button>-->
        </form>
    </div>
</nav>

<div class="row wrapper-editor">
    <!-- section block -->
    <div *ngIf="openBlock" id="section_left" class="section-left card card-white col-12 col-lg-3">
        <div *ngIf="!loading" class="section-blocks d-flex flex-column">
            <h2 class="site-text">Site Blocks</h2>
            <!-- <div *ngFor="let block of siteBlocks" class="box-gray" (click)="toggleBlock(block.name, block.schema, block.template_id)">
                <span class="box-title">{{ block.name }}</span>
                <span>
                    <i class="arrow right"></i>
                </span>
            </div> -->
            <div class="box-gray" (click)="toggleBlock('Header','',1)">
                <span class="box-title">Header</span>
                <span>
                    <i class="arrow right"></i>
                </span>
            </div>
            <div class="box-gray" (click)="toggleBlock('Category','',1)">
                <span class="box-title">Category</span>
                <span>
                    <i class="arrow right"></i>
                </span>
            </div>
            <div class="box-gray" (click)="toggleBlock('Products','',1)">
                <span class="box-title">Products</span>
                <span>
                    <i class="arrow right"></i>
                </span>
            </div>
            <div class="box-gray" (click)="toggleBlock('Footer','',1)">
                <span class="box-title">Footer</span>
                <span>
                    <i class="arrow right"></i>
                </span>
            </div>

            <!-- <div class="box-white" (click)="addBlock()"> -->
            <!-- <div class="box-white">
                <span class="plus-icon">+</span>
                <span class="box-title text-center">Add Block</span>
            </div> -->
        </div>
        <div *ngIf="loading" class="section-blocks d-flex justify-content-center">
            <div class="mt-4 text-center">
                <div class="loading-spinner col-12">
                    <mat-spinner class="mx-auto my-3" [diameter]="50"></mat-spinner>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="openActiveBlock" class="section-left card card-white col-12 col-lg-3">
        <div class="section-blocks d-flex flex-column">
            <h2 class="site-text">{{ activeBlockName }}</h2>
            <form id="form"></form>
        </div>
    </div>
    <!-- section block -->

    <!-- test iframe preview store -->
    <div class="section-store-preview col-12 col-lg-9 p-0">
        <!-- <h4 class="site-text">Output Data JSON</h4>
        <div class="card">
            
            <div class="card-body">
                <textarea [ngModel]="dataOutput" (dataJsonUpdate)="handleDataJsonUpdate($event)"  id="data-output-textarea"></textarea>
            </div>
        </div> -->

        <div>
            <!-- <h2 class="site-text">{{ activeBlockName }}</h2> -->

            <div class="col-12 mt-1 pr-0">
                <iframe id="editor-preview" src="https://editor-preview-store.estore5s.com/"></iframe>
            </div>

        </div>
    </div>
    <!-- test iframe preview store -->
</div>